import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SearchBarComponent } from '@search/ui';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DeployUrlPipe } from '@innogy/utils/environment';

import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'wl-search-header',
  standalone: true,
  imports: [DeployUrlPipe, RouterModule, SearchBarComponent, FontAwesomeModule],
  templateUrl: './search-header.component.html',
  styleUrls: ['./search-header.component.essent.scss'],
})
export class SearchHeaderComponent {
  showSearchNavigation = inject(NavigationService).searchNavigationEnabled;

  close() {
    this.showSearchNavigation.set(false);
  }
}
